import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/service/config.service';

@Component({
  selector: 'app-main-auction-card',
  templateUrl: './main-auction-card.component.html',
  styles: [
  ]
})
export class MainAuctionCardComponent implements OnInit {

  @Input() AuctionDetailes: any;
  @Input() type: any = '';
  constructor(public _config: ConfigService) { }

  ngOnInit(): void {

  }

  OnNavigate(auction_id: string) {
    let URL = ''

    let User = this._config.getAuthUserInfo()
    if (User?.user?.role_code == "General" || !User) {
      if (Number(this.AuctionDetailes.is_multi_auction)) {
        URL = '/mulit-auction/';
      } else {
        URL = '/MainAuction/';
      }
    } else {
      if (this.AuctionDetailes.is_multi_auction) {
        URL = '/rooms/Multi/detailes/';

      } else {
        URL = '/rooms/detailes/';

      }
    }

    this._config._router.navigate([URL, auction_id])
    // const url = this._config._router.createUrlTree([URL, auction_id])
    // window.open(url.toString(), '_blank')
  }
}
